"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getter_1 = require("./getter");
var decorator_1 = require("./decorator");
function dateOr(root, path, decorators, orElse) {
    if (path === void 0) { path = ''; }
    if (decorators === void 0) { decorators = []; }
    if (orElse === void 0) { orElse = new Date(); }
    /*
     * try/catch left to be compatible with some ES versions.  Post ES5
     * will no longer thrown an exception for non-date strings but instead
     * returns an 'Invalid Date'
     *
     * See https://stackoverflow.com/questions/1353684/detecting-an-invalid-date-date-instance-in-javascript
     *
     */
    try {
        return [].concat(new Date(decorator_1.decorate(getter_1.getDefinedOrElse(root, path, orElse), decorators))).map(function (possibleDate) {
            return (!isNaN(possibleDate.getTime())) ?
                possibleDate : orElse;
        }).shift();
    }
    catch (e) {
        return orElse;
    }
}
exports.dateOr = dateOr;
//# sourceMappingURL=dateOr.js.map